import { fetcher } from "helpers/fetcher";

import {
  TRemoveCurrentStaffStatusReq,
  TRemoveCurrentStaffStatusRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const removeCurrentStaffStatus = async (
  payload: TRemoveCurrentStaffStatusReq
) => {
  return await fetcher<
    TRemoveCurrentStaffStatusRes,
    TRemoveCurrentStaffStatusReq["data"]
  >(ENDPOINT.CORPORATION.REMOVE_CURRENT_STAFF_STATUS, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationRemoveCurrentStaffStatus = async (
  payload: TRemoveCurrentStaffStatusReq
) => {
  return (await removeCurrentStaffStatus(payload)).data;
};

mutationRemoveCurrentStaffStatus._key = (
  payload: TRemoveCurrentStaffStatusReq
) => [ENDPOINT.CORPORATION.REMOVE_CURRENT_STAFF_STATUS.url, payload];
